import SuperEllipse from "react-superellipse";
import ResizeListener from "../../utility/ResizeListener";
import { BG_COLOR } from "../resources/colorsManager";
import { PX_20 } from "../resources/valuesManager";
import "../../hide-scroll.css";
const BodyComponent = ({ children, style }) => {
  const { height } = ResizeListener();
  return (
    <SuperEllipse
      r1={0.01}
      r2={0.05}
      style={{
        minHeight: height * 0.85,
        width: "85%",
        backgroundColor: BG_COLOR,
        borderRadius: PX_20,
        marginLeft: PX_20,
        boxSizing: "border-box",
        padding: "20px",
        transition: "background-color 0.5s cubic-bezier(0.42,0,0.58,1)",
        minWidth: 500,
        overflowY: "scroll",
        ...style,
      }}
    >
      {children}
    </SuperEllipse>
  );
};

export default BodyComponent;
